import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : "";
      // Strip the hash so it doesn't linger
      if (window.history.replaceState) {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
      }
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        await api.post("/auth/session", { session_id: sessionId });
        const me = await refresh();
        // If profile isn't complete, force them into onboarding. Google auth
        // alone doesn't grant a real seat on Oiiister.
        if (me && !me.profile_complete) {
          navigate("/my/profile", { replace: true });
          return;
        }
        const returnTo = location.pathname === "/auth/callback" ? "/" : location.pathname;
        navigate(returnTo, { replace: true });
      } catch {
        navigate("/login?error=auth", { replace: true });
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-[#4B5563]">
      <Loader2 className="animate-spin text-[#3FFFB6]" size={28} />
      <p className="mt-3 font-body text-sm">Signing you in…</p>
    </div>
  );
}
